// extracted by mini-css-extract-plugin
export default {"documentsLanguage":"DocumentsLanguage_documentsLanguage__JyTx0","answers":"DocumentsLanguage_answers__5dYMa"};